import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import globalsCss from "@/styles/globals.css?url";
import { RootDocument } from "@/routes/-components/root-document";

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({
    meta: [
      { charSet: "utf-8" },
      /* `interactive-widget`: when a phone's keyboard opens, the page fits above it, so a reply box
         or a Save bar pinned to the foot stays in sight instead of under the keys. Android honours
         it; iOS and every desk (no on-screen keyboard) ignore it. */
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1, interactive-widget=resizes-content",
      },
      { title: "People AI" },
      /* The light --background, for first paint. ThemeColourSync repaints it to the page's own
       * colour once the stored theme is known (the OS preference does not pick the theme). */
      { name: "theme-color", content: "#f7f5f1" },
      /* Home-screen launches open full screen. iOS keeps a page inside the app
         only while it is in the manifest's scope ("/"); without a manifest it
         guessed one, and later pages opened in a Safari sheet. */
      { name: "apple-mobile-web-app-capable", content: "yes" },
      { name: "mobile-web-app-capable", content: "yes" },
      { name: "apple-mobile-web-app-title", content: "People AI" },
      { name: "apple-mobile-web-app-status-bar-style", content: "default" },
    ],
    links: [{ rel: "stylesheet", href: globalsCss }],
  }),
  component: RootLayout,
});

function RootLayout() {
  return (
    <RootDocument>
      <Outlet />
    </RootDocument>
  );
}
